import moment from 'services/moment'

export const handleLessonsExpiredDate = (date, t) => {
  if (date === null || date === 'null') return t('expired-date-null')
  if (date === -1) return t('dashboard-accessible')
  return t('dashboard-accessible-until') + ' ' + moment.toDefaultFormatShort(date)
}
